import styled from 'styled-components';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

export const Container = styled.div`
  
`;

export const TooltipPrimitiveContent = styled(TooltipPrimitive.Content)`
  border-radius: 4px;
  padding: 10px 15px;
  font-size: 15px;
  line-height: 1;
  color: var(--violet-11);
  background-color: ${props => props.theme.colors.card};
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  user-select: none;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  z-index:1
`;
